const CumulativeReturnTable = require('./CumulativeReturnTable');

module.exports = CumulativeReturnTable;
